<template>
  <v-btn-form :title="title" @close="cancel()">
    <v-form v-model="valid" ref="form">
      <v-card-text>
        <v-layout column>
        <v-flex v-html="text">
        </v-flex>
          <v-flex>
          <v-textarea
            label="Описание оферты"
            rows="3"
            hint=""
            v-model="contentText"
            :rules="[v=>!!v || 'введите краткое описание']"                        
            clearable
          ></v-textarea>
        </v-flex>
        <v-flex>
          <v-text-field
            prepend-icon="attach_file"
            @click:prepend="dialogOpen"          
            label="Ссылка на документ"
            hint=""
            v-model="item.link"
            :rules="[v=>!!v || 'cсылка должна быть указана']"            
            clearable
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-date-field
            label="Срок ответа не позднее"
            :rules="[]"
            hint=""
            v-model="item.expiryTime"
          >
          </v-date-field>
        </v-flex>
      </v-layout>
      </v-card-text>
    </v-form>
    <template #actions>
      <v-btn :disabled="!valid" @click="add">Направить</v-btn>
      <v-spacer></v-spacer>    
    </template>
  </v-btn-form>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import moment from 'moment'
  import vDateField from '../common/DateField.vue'
  import depo from '../depo'
  import vBtnForm from '../common/BtnForm'

  export default {
    name: 'post-offer-request-form',
    components: {vDateField, vBtnForm},
    data: () => ({
      edit: false,
      valid: false,
      item: {},
      agreementNumber: '',
      contentText: null
    }),
    props: {
      itemId: {
        type: Number,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.item = this.getItemNew()
    },
    mounted () {
    },
    watch: {
    },
    computed: {
      ...mapGetters({
        chat: 'getChatterChat',
        profile: 'getProfile',
        getDepoUrl: 'getDepoUrl'
      }),
      partnerName () {
        return this.chat && this.chat.partnerName ? this.chat.partnerName : '[Название компании]'
      },
      partnerInn () {
        return this.chat && this.chat.partnerInn ? this.chat.partnerInn : '[ИНН компании]'
      },
      clientName () {
        return this.profile && this.profile.clientNameShort ? this.profile.clientNameShort : '[Название компании]'
      },
      clientInn () {
        return this.profile && this.profile.clientInn ? this.profile.clientInn : '[ИНН компании]'
      },
      expiryTime () {
        return this.item.expiryTime ? formats.formatDate(moment(this.item.expiryTime)) : ''
      },
      docLink () {
        return this.item.link ? this.item.link : '[Ссылка на файл]'
      },
      offerContent () {
        return this.contentText ? this.contentText : '[Описание оферты]'
      },
      title () {
        return 'Направить запрос оферты / коммерческого предложения'
      },
      text: {
        get () {
          return this.getText()
        }
      }
    },
    methods: {
      add () {
        if (this.$refs.form.validate()) {
          this.item.text = this.getText()
          this.item.chatId = this.chat.id
          this.$store.dispatch('addChatterPost', this.item)
          this.edit = false
          this.cancel()
        }
      },
      cancel () {
        this.edit = false
        this.item = Object.assign({}, this.getItemNew())
        this.$emit('close')
      },
      getItemNew () {
        return {
          id: null,
          chatId: null,
          text: '',
          typeCode: 'OFFER_REQUEST',
          expiryTime: moment().add(5, 'days').format(),
          link: null
        }
      },
      getText () {
        return `${this.clientName}, ИНН ${this.clientInn} предлагает ${this.partnerName}, ИНН ${this.partnerInn} направить свою оферту о ${this.offerContent}. Полный текст запроса находится в файле по адресу: <a href="${this.docLink}">${this.docLink}</a>. Срок для направления оферты не позднее ${this.expiryTime}.`
      },
      setDoc: function (value) {
        var docLink = this.getDepoUrl(value)
        this.item.link = docLink
      },
      dialogOpen: function () {
        depo.selectDoc(this, this.setDoc)
      }
    }

  }

</script>




// WEBPACK FOOTER //
// PostOfferRequestForm.vue?a0cf992e